import React from 'react';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingTimelineFrameRate, selectPlayerCurrentFrame } from '@/redux/selectors/packagingSelectors';
import { getSMPTETimecode } from '@/components/Packaging/utils';

const CurrentFrameIndicator: React.FC = () => {
  const currentFrame = useAppSelector(selectPlayerCurrentFrame);
  const frameRate = useAppSelector(selectPackagingTimelineFrameRate);
  return <Wrapper>{getSMPTETimecode(currentFrame, frameRate)}</Wrapper>;
};

export default CurrentFrameIndicator;

const Wrapper = styled.div`
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  color: #ffffff;
`;
